<template>
  <div class="pagee">
    <img class="img1" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x50.png" alt="">
    <img class="img2" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x51.png" alt="">
    <div class="page-container">
      <div class="news-section">
        <div class="left-news">
          <div class="header">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <div class="title">院校新闻</div>
              <div @click="goNext(`/xqxx?uName=新闻资讯&dname=院校新闻`)" class="more">更多
                <img style="width: 6px;display: inline-block;"
                  src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x26.png" alt="">
              </div>
            </div>

          </div>
          <div v-if="newsList1" @click="goNext(`/xxxq?id=${newsList1.id}&uName=新闻资讯&dname=院校新闻`)"
            style="display: flex;position: relative;justify-content: flex-end;margin-top: 20px;">


            <div class="main-news">
              <img :src="newsList1.img" alt="main news" />
              <div class="date-tag">
                <div class="day">{{ formatDate(newsList1.addTime).day }}</div>
                <div class="year">{{ formatDate(newsList1.addTime).year }}.{{ formatDate(newsList1.addTime).month }}
                </div>
              </div>
              <div class="desc">{{ newsList1.introduction }}</div>
            </div>
            <div class="news-list">
              <div @click="goNext(`/xxxq?id=${item.id}&uName=新闻资讯&dname=院校新闻`)" v-for="(item, index) in newsList"
                :key="index" class="news-item">
                <div class="news-date">{{ item.addTime.slice(0, 10) }}</div>
                <div class="news-title elp">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-news">
          <div class="header">
            <div class="title">通知公告</div>
            <div @click="goNext(`/xqxx?uName=新闻资讯&dname=通知公告`)" class="more">更多
              <img style="width: 6px;display: inline-block;"
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x26.png" alt="">
            </div>
          </div>
          <div class="notice-list">
            <div @click="goNext(`/xxxq?id=${item.id}&uName=新闻资讯&dname=通知公告`)" v-for="(item, index) in rightNewsList"
              :key="index" class="notice-item">
              <div class="notice-date">
                <div class="notice-day">{{ formatDate(item.addTime).day }}</div>
                <div class="notice-year">{{ formatDate(item.addTime).year }}.{{ formatDate(item.addTime).month }}</div>
              </div>
              <div class="notice-title twoEllipsis">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="function-buttons">
        <div @click="goFunctionPage(btn)" v-for="(btn, index) in buttons" :key="index" class="btn-item">
          <img :src="btn.imgUrl" alt="icon" />
          <div class="btn-text">
            <div class="tt1 elp"> {{ btn.title }}</div>
            <div class="tt2 ">
              <div style="max-width: 70px;" class="elp">{{ btn.fuTitle }} </div>
              <img style="width: 7px;height: 10px;margin-left: 6px;"
                src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x24.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Know } from '@/api/know'
const know = new Know()
import { queryAllArticle, getEntrantsRelationPcJinGang } from "@/api/home";

export default {
  name: "NewsDynamic",
  data() {
    return {
      newsList: [],
      newsList1: [],
      rightNewsList: [],
      buttons: []
    };
  },
  created() {
    this.getList()
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      // 补 0 处理月份
      const month = String(date.getMonth() + 1).padStart(2, '0');
      // 补 0 处理日期
      const day = String(date.getDate()).padStart(2, '0');
      return { year, month, day };
    },
    async getList() {

      queryAllArticle("", 6, 1, undefined, '院校新闻').then((res) => {
        if (res.rows && res.rows.length > 0) {
          this.newsList1 = res.rows[0];
          this.newsList = res.rows.slice(1);
        } else {
          this.newsList1 = '';
          this.newsList = [];
        }
      });
      queryAllArticle("", 5, 1, undefined, '通知公告').then((res) => {

        this.rightNewsList = res.rows;
      });
      getEntrantsRelationPcJinGang({}).then((res) => {
        this.buttons = res.data.jinGangDistrictList;
      });

    },
    goFunctionPage(item) {
      if (item.nameUrl) {
        window.open(item.nameUrl, '_blank');
      }
    }
  }

};
</script>

<style lang="scss" scoped>
.pagee {
  position: relative;

  .img1 {
    position: absolute;
    width: 360px;
    top: 0;
    left: 0;
  }

  .img2 {
    position: absolute;
    width: 600px;
    top: 0;
    right: 0;
  }

}

.page-container {
  width: 1200px;
  margin: 0 auto;
  margin-top: 32px;

  position: relative;
  z-index: 99;

  .news-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    .left-news {
      width: 892px;

      .title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 24px;
        color: #333333;
      }

      .more {

        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #777777;
        cursor: pointer;
      }

      .main-news {
        position: absolute;
        left: 40px;
        z-index: 999;
        width: 493px;

        position: relative;
        border-radius: 10px;

        img {
          width: 493px;
          height: 338px;
          border-radius: 16px 16px 16px 16px;
        }

        .date-tag {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 60px;
          height: 60px;
          background: linear-gradient(180deg, #FD819E 0%, #FF2C63 100%);
          border-radius: 4px 4px 4px 4px;
          font-family: MiSans, MiSans;
          font-weight: 500;
          font-size: 20px;
          color: #FFFFFF;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .day {}

          .year {
            font-size: 12px;
          }
        }

        .desc {
          position: absolute;
          bottom: 0;
          left: 25px;
          width: 450px;
          height: 52px;
          padding: 16px 23px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          /* background: #fff; */
          background-image: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x25.png');
          background-size: 100% 100%;

          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 15px;
          color: #FFFFFF;
        }
      }

      .news-list {
        width: 440px;
        height: 372px;
        background: #FFFFFF;
        border-radius: 0px 16px 16px 0px;
        flex-shrink: 0;
        padding: 10px 20px;
        padding-left: 56px;

        .news-item {
          height: 72px;
          cursor: pointer;
          border-bottom: 2px dashed #EEE;
          /* 1px 黑色虚线 */
          border-image: repeating-linear-gradient(90deg, #EEE, #EEE 5px, transparent 5px, transparent 10px);
          border-image-slice: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;

          &:last-child {
            border-bottom: 0;
          }

          .news-date {

            font-family: MiSans, MiSans;
            font-weight: 500;
            font-size: 13px;
            color: #0074EF;
          }

          .news-title {

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 15px;
            color: #333333;
            margin-top: 6px;
          }
        }
      }
    }

    .right-news {
      width: 290px;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .title {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 24px;
          color: #333333;
        }

        .more {

          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #777777;
          cursor: pointer;
        }
      }

      .notice-list {

        margin-top: -10px;

        .notice-item {
          display: flex;
          cursor: pointer;
          border-bottom: 2px dashed #EEE;
          /* 1px 黑色虚线 */
          border-image: repeating-linear-gradient(90deg, #EEE, #EEE 5px, transparent 5px, transparent 10px);
          border-image-slice: 1;
          padding-bottom: 13px;
          padding-top: 13px;

          &:last-child {
            border-bottom: 0;
          }

          .notice-date {
            width: 62px;
            height: 51px;
            background: linear-gradient(180deg, #509FFF 0%, #086AEB 100%);
            border-radius: 4px 4px 4px 4px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
            flex-shrink: 0;


            .notice-day {

              font-family: MiSans, MiSans;
              font-weight: 500;
              font-size: 18px;
              color: #FFFFFF;
            }

            .notice-year {

              font-family: MiSans, MiSans;
              font-weight: 500;
              font-size: 12px;
              color: #FFFFFF;
            }
          }

          .notice-title {
            height: 43px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 15px;
            color: #333333;
            /* line-height: 23px; */
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .function-buttons {
    display: flex;
    justify-content: space-between;
    border-radius: 10px;

    .btn-item {
      width: 185px;
      height: 76px;
      background: #FFFFFF;
      box-shadow: 0px 0px 12px 1px rgba(204, 204, 204, 0.3);
      border-radius: 12px 12px 12px 12px;
      padding: 12px 20px;
      display: flex;
      cursor: pointer;

      img {
        width: 48px;
        height: 54px;
        margin-right: 12px;
      }

      .btn-text {
        .tt1 {

          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          margin-top: 6px;
        }

        .tt2 {
          margin-top: 6px;

          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #777777;
          line-height: 16px;
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
</style>